import { Col, Row, Table } from "antd";
import ConfirmationCard from "../components/statitistics/confirmationCard";
import PieChart from "../components/charts/PieChart";
import BarChart from "../components/charts/BarChart";
import { getData } from "../helpers/api";
import { useEffect, useState } from "react";
import { getLocalStorage } from "../helpers/localstorage";
import { rolesConst } from "../constants/others";
import { changeBgColor } from "../utils/changeColor";
import { useLocation } from 'react-router-dom';

const Dashboard = () => {
    const location = useLocation();
    const [statistics, setStatistics] = useState({
        totalOrders: 0,
        statistics: []
    })
    const [productStatistics, setProductStatistics] = useState({
        totalOrders: 0,
        statistics: []
    })
    const [usersStatistics, setUsersStatistics] = useState([])
    const [filter, setFilter]= useState({})

    const user = getLocalStorage("auth")?.user
    const getDeliveryStatusStatistics = async () => {
        try {
            const { data } = await getData("/statistics/delivery-status-stats")
            setStatistics(data)
        } catch (error) {
            console.log("error", error)
        }
    }
    const getProductStatistics = async () => {
        try {
            const { data } = await getData("/statistics/product-stats")
            setProductStatistics(data)
        } catch (error) {
            console.log("error", error)
        }
    }

    const getUserStatistics = async () => {
        try {
            const { data } = await getData("/statistics/user-stats")
            setUsersStatistics(data)
        } catch (error) {
            console.log("error", error)
        }
    }

    useEffect(() => {
        getDeliveryStatusStatistics()
        getProductStatistics()
        getUserStatistics()
    }, [filter])
    
    const columns = [
        {
            title: 'Prefix',
            dataIndex: 'label',
            key: 'label',
        },
        {
            title: 'Confirmeé',
            dataIndex: 'confirmedCount',
            key: 'confirmedCount',
        },
        {
            title: 'Livré',
            dataIndex: 'deliveredCount',
            key: 'deliveredCount',
        },
        {
            title: 'Taux de confirmation',
            dataIndex: 'confirmedPercent',
            key: 'confirmedPercent',
        },
        {
            title: 'Taux de livraison',
            dataIndex: 'deliveredPercent',
            key: 'deliveredPercent',
        },
    ];

    return (
        <>
            {user?.role === rolesConst.SuperAdmin &&
                <>
                    <Row style={{ background: "#f5f5f5" }} gutter={[12, 8]}>
                        <Col lg={24} xs={24}>
                            <p style={{ textAlign: "left" }}>Total commandes: {statistics.totalOrders}</p>
                        </Col>
                        {statistics.statistics.map((el, index) => (
                            <Col key={index} lg={6} md={8} sm={24} xs={24}>
                                <ConfirmationCard statistic={el} />
                            </Col>
                        ))}
                    </Row>

                    <Row gutter={[10, 10]} justify="space-around" style={{ margin: "unset", marginTop: 10 }}>
                        <Col className="barchart-container" lg={11} md={24} sm={24} xs={24} style={{ borderRadius: 8, background: "white",boxShadow:"0px 0px 5px 0px rgba(192,191,196,0.75)" }}>
                            <BarChart
                                labels={statistics.statistics.map((el) => el.label)}
                                resource={statistics.statistics.map((el) => el.count)}
                                backgroundColors={statistics.statistics.map((el) => changeBgColor(el.label))}
                            />
                        </Col>
                        <Col lg={2} md={0} sm={0} xs={0}></Col>
                        <Col lg={11} md={24} sm={24} xs={24} style={{ borderRadius: 8, background: "white",boxShadow:"0px 0px 5px 0px rgba(192,191,196,0.75)" }}>
                            <PieChart
                                labels={productStatistics.statistics.map((el) => el.label)}
                                resource={productStatistics.statistics.map((el) => el.count)}
                                label={"Nbr de commandes"}
                            />
                        </Col>
                    </Row>
                    <Row style={{ margin: "unset", marginTop: 20 }}>
                        <Col
                            lg={24}
                            style={{
                                borderRadius: 8,
                                overflow: "hidden",
                                background: "white",
                                overflowX: "auto",
                                overflowY: "auto",
                                boxShadow:"0px 0px 5px 0px rgba(192,191,196,0.75)"
                            }}
                        >
                            <Table pagination={false} dataSource={usersStatistics} columns={columns} />
                        </Col>
                    </Row>
                </>
            }
        </>
    );
}

export default Dashboard;